const keyMirror = require("keymirror");

export const AuditLogConstants = keyMirror({
  FETCH_AUDIT_LOG: undefined,
  CREATE_AUDIT_LOG: undefined
});
